// src/pages/GridViewTestPage.tsx
import React, { useState, useEffect } from 'react';
import { GridView } from '@/components/GridView/GridView';
import { authStorage } from '@/lib/storage';
import type { ConversationDetail } from '@/types/conversation';

const GridViewTestPage: React.FC = () =>
{
  const [dashboardId, setDashboardId] = useState<number>(205611);
  const [inputDashboardId, setInputDashboardId] = useState<string>('205611');
  const [projectId, setProjectId] = useState<string>('');
  const [inputProjectId, setInputProjectId] = useState<string>('');
  const [searchText, setSearchText] = useState<string>('');
  const [inputSearchText, setInputSearchText] = useState<string>('');
  const [configValueId, setConfigValueId] = useState<number | undefined>(undefined);
  const [inputConfigValueId, setInputConfigValueId] = useState<string>('');
  const [key, setKey] = useState<number>(0);
  const [hasToken, setHasToken] = useState<boolean>(false);

  useEffect(() =>
  {
    const token = authStorage.getAccessToken();
    setHasToken(!!token);
  }, []);

  const handleApplySettings = (e: React.FormEvent) =>
  {
    e.preventDefault();
    const newDashboardId = parseInt(inputDashboardId, 10);
    if (!isNaN(newDashboardId) && newDashboardId > 0)
    {
      setDashboardId(newDashboardId);
    }
    setProjectId(inputProjectId);
    setSearchText(inputSearchText);
    const cv = parseInt(inputConfigValueId, 10);
    setConfigValueId(!isNaN(cv) && cv > 0 ? cv : undefined);
    setKey(prev => prev + 1);
  };

  const handleOpenInfoWindow = (_conversation: ConversationDetail) => {};

  const handleUpdateConversation = (
    _conversationId: number,
    _updates: Partial<ConversationDetail>,
  ) => {};

  const labelStyle: React.CSSProperties = {
    display: 'block',
    marginBottom: 5,
    fontWeight: 'bold',
    fontSize: 14,
  };

  const inputStyle: React.CSSProperties = {
    padding: '8px 12px',
    border: '1px solid #ccc',
    borderRadius: 4,
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: 20,
          backgroundColor: 'white',
          borderBottom: '1px solid #ddd',
          flexShrink: 0,
        }}
      >
        <h1 style={{ margin: '0 0 15px 0', color: '#333' }}>GridView Test Page</h1>

        <div
          style={{
            padding: '10px 15px',
            marginBottom: 15,
            borderRadius: 4,
            backgroundColor: hasToken ? '#e8f5e9' : '#ffebee',
            color: hasToken ? '#2e7d32' : '#c62828',
          }}
        >
          {hasToken
            ? '✅ Token detected — using dynamic authentication'
            : '⚠️ No token found — please login first'}
        </div>

        <form onSubmit={handleApplySettings}>
          <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 15 }}>
            <div>
              <label style={labelStyle}>Dashboard ID:</label>
              <input
                type="number"
                value={inputDashboardId}
                onChange={e => setInputDashboardId(e.target.value)}
                style={{ ...inputStyle, width: 120 }}
              />
            </div>
            <div>
              <label style={labelStyle}>Config Value ID (optional):</label>
              <input
                type="text"
                value={inputConfigValueId}
                onChange={e => setInputConfigValueId(e.target.value)}
                placeholder="e.g., 9"
                style={{ ...inputStyle, width: 120 }}
              />
            </div>
            <div>
              <label style={labelStyle}>Project ID (optional):</label>
              <input
                type="text"
                value={inputProjectId}
                onChange={e => setInputProjectId(e.target.value)}
                placeholder="e.g., 123"
                style={{ ...inputStyle, width: 120 }}
              />
            </div>
            <div>
              <label style={labelStyle}>Search Text:</label>
              <input
                type="text"
                value={inputSearchText}
                onChange={e => setInputSearchText(e.target.value)}
                placeholder="Search..."
                style={{ ...inputStyle, width: 200 }}
              />
            </div>
          </div>

          <button
            type="submit"
            style={{
              padding: '10px 20px',
              backgroundColor: '#1877f2',
              color: 'white',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 'bold',
            }}
          >
            Apply Settings & Reload
          </button>

          <span style={{ marginLeft: 16, fontSize: 12, color: '#666' }}>
            Dashboard #{dashboardId}
            {configValueId ? ` | ConfigValue: ${configValueId}` : ''}
            {projectId ? ` | Project: ${projectId}` : ''}
            {searchText ? ` | Search: "${searchText}"` : ''}
          </span>
        </form>
      </div>

      {/* GridView fills the remaining height */}
      <div style={{ flex: 1, overflow: 'hidden', padding: 20 }}>
        <GridView
          key={key}
          dashboardId={dashboardId}
          configValueId={configValueId}
          projectId={projectId || undefined}
          searchText={searchText || undefined}
          isActive={true}
          onOpenInfoWindow={handleOpenInfoWindow}
          onUpdateConversation={handleUpdateConversation}
        />
      </div>
    </div>
  );
};

export default GridViewTestPage;
